import { render, staticRenderFns } from "./InsightsCard.vue?vue&type=template&id=dfcd649c"
import script from "./InsightsCard.vue?vue&type=script&lang=js"
export * from "./InsightsCard.vue?vue&type=script&lang=js"
import style0 from "./InsightsCard.vue?vue&type=style&index=0&id=dfcd649c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports